import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useOrgHierarchySync } from "../hooks/useOrgHierarchySync";
import { useIdleLogout } from "../hooks/useIdleLogout";
import { clearAppStorage } from "../services/storage";
import LoadingSpinner from "./LoadingSpinner";
import LicenceBanner from "./LicenceBanner";

const PrivateRoute = () => {
  const { user, token, initialized } = useAuth();

  // Sync org hierarchy from backend (on mount, periodically, and on visibility change)
  // Note: refreshOrgHierarchy is available but not needed here - it's used in TenantSelection
  useOrgHierarchySync();

  // Log out after 30 minutes of no user activity (sliding inactivity timeout).
  useIdleLogout();

  // Wait for AuthContext to initialize from localStorage
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // Check for valid authentication: need both token and user with required properties
  const isValidUser = user && user.id !== undefined && token;

  if (!isValidUser) {
    // Save intended destination before clearing auth state
    const intended = window.location.pathname + window.location.search;
    if (intended !== '/login' && intended !== '/logout' && intended !== '/') {
      sessionStorage.setItem("returnUrl", intended);
    }
    clearAppStorage();
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <LicenceBanner />
      <Outlet />
    </>
  );
};

export default PrivateRoute;
